import React from 'react';
import { useAuth } from './contexts/AuthContext';
import { 
  GridContainer, ScanLine, NavbarContainer, Logo, 
  NavLinks, NavLink, MainContent, UserInfo, UserName, LogoutButton
} from './components/Layout';

const Layout = ({ children }) => {
  const { user, logout } = useAuth();
  
  return (
    <>
      <GridContainer />
      <ScanLine />
      <NavbarContainer>
        <Logo to="/">
          <span>DH</span>
          Digital Human
        </Logo>
        <NavLinks>
          <NavLink to="/">首页</NavLink>
          <NavLink to="/clone">数字人</NavLink>
          <NavLink to="/voice">声音合成</NavLink>
          <NavLink to="/video">视频生成</NavLink>
          <NavLink to="/gallery">作品库</NavLink>
          <NavLink to="/config">配置中心</NavLink>
          <NavLink to="/agent">智能体</NavLink>
          <NavLink to="/search">IP搜索</NavLink>
          <NavLink to="/mix-cut">视频混剪</NavLink>
          <NavLink to="/super-ip">超级IP</NavLink>
          {user?.is_admin === 1 && <NavLink to="/admin">管理后台</NavLink>}
        </NavLinks>
        {user && (
          <UserInfo>
            <UserName>
              {user.username}
              {user.is_admin === 1 && <span className="admin-badge">管理员</span>}
            </UserName>
            <LogoutButton onClick={logout}>
              登出
            </LogoutButton>
          </UserInfo>
        )}
      </NavbarContainer>
      <MainContent>
        {children}
      </MainContent>
    </>
  );
};

export default Layout;
